import React from 'react';
import Icon from '../../../icon';

const ArrowRight = ({ moveRight }) => {
  return (
    <button className={'modal-mosaic__arrow-next'} onClick={moveRight}>
      <Icon iconName={'arrow-chevron-right'} color={'white'} size={24} />
    </button>
  );
};

export default ArrowRight;
